/** Advisory configuration for the submission layer. SDK does not send — caller decides. */
export interface TransactionLandingConfig {
  defaultCommitment: 'confirmed' | 'finalized';
  simulateBeforeSend: boolean;
  maxRetries: number;
  blockhashTtlMs: number;
}

/** Recommended defaults for transaction landing. */
export const RECOMMENDED_LANDING_CONFIG: TransactionLandingConfig = {
  defaultCommitment: 'confirmed',
  simulateBeforeSend: true,
  maxRetries: 3,
  blockhashTtlMs: 60_000,
};
